export const PRESENCE_INPUT = 'PRESENCE_INPUT' as const;
export const PRESENCE_OUTPUT = 'PRESENCE_OUTPUT' as const;
